import { render, staticRenderFns } from "./alliance.vue?vue&type=template&id=317692b1&scoped=true&"
import script from "./alliance.vue?vue&type=script&lang=js&"
export * from "./alliance.vue?vue&type=script&lang=js&"
import style0 from "./alliance.vue?vue&type=style&index=0&id=317692b1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317692b1",
  null
  
)

export default component.exports